import React from "react";
import { FaEnvelope, FaImage, FaPen, FaShieldAlt, FaTimes, FaUser } from "react-icons/fa";

import {
  getFullName,
  getMediaUrl,
  getRoleClass,
  getRoleLabel,
} from "../utils/leClubUtils";

function DetailItem({ label, value, icon: Icon }) {
  return (
    <div className="rounded-3xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-900">
      <div className="flex items-start gap-3">
        {Icon && (
          <span className="grid h-10 w-10 shrink-0 place-items-center rounded-2xl bg-white text-slate-500 dark:bg-slate-950 dark:text-slate-300">
            <Icon />
          </span>
        )}

        <div className="min-w-0">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-slate-400">
            {label}
          </p>
          <p className="mt-1 break-words text-sm font-semibold text-slate-800 dark:text-slate-100">
            {value || "—"}
          </p>
        </div>
      </div>
    </div>
  );
}

export default function UserDetails({ user, onEdit, onClose }) {
  const imageUrl = getMediaUrl(user.photoURL);

  return (
    <div className="space-y-6">
      <section className="rounded-[2rem] border border-slate-200 bg-slate-50 p-5 dark:border-slate-800 dark:bg-slate-900">
        <div className="flex flex-col items-center gap-5 text-center sm:flex-row sm:text-left">
          <div className="h-32 w-32 overflow-hidden rounded-[2rem] bg-slate-100 dark:bg-slate-800">
            {imageUrl ? (
              <img
                src={imageUrl}
                alt={getFullName(user)}
                className="h-full w-full object-cover"
              />
            ) : (
              <div className="flex h-full items-center justify-center text-slate-400">
                <FaImage className="text-4xl" />
              </div>
            )}
          </div>

          <div className="min-w-0">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-orange-600 dark:text-orange-300">
              Utilisateur
            </p>

            <h3 className="mt-1 text-3xl font-bold text-slate-950 dark:text-white">
              {getFullName(user)}
            </h3>

            <span
              className={`mt-3 inline-flex rounded-full px-3 py-1 text-xs font-bold ${getRoleClass(
                user.role_id
              )}`}
            >
              {getRoleLabel(user.role_id)}
            </span>
          </div>
        </div>
      </section>

      <section>
        <h4 className="mb-3 text-sm font-bold uppercase tracking-[0.18em] text-slate-400">
          Informations
        </h4>

        <div className="grid gap-3 sm:grid-cols-2">
          <DetailItem label="Nom complet" value={getFullName(user)} icon={FaUser} />
          <DetailItem label="Email" value={user.email} icon={FaEnvelope} />
          <DetailItem label="Rôle" value={getRoleLabel(user.role_id)} icon={FaShieldAlt} />
          <DetailItem label="Mot de passe" value="Non affiché" icon={FaShieldAlt} />

          <div className="sm:col-span-2">
            <DetailItem
              label="Photo"
              value={user.photoURL || "Non renseignée"}
              icon={FaImage}
            />
          </div>
        </div>
      </section>

      <div className="sticky bottom-0 -mx-5 border-t border-slate-200 bg-white/90 px-5 py-4 backdrop-blur dark:border-slate-800 dark:bg-slate-950/90">
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            <FaTimes />
            Fermer
          </button>

          <button
            type="button"
            onClick={onEdit}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-950 px-4 py-3 text-sm font-bold text-white shadow-lg shadow-slate-950/20 transition hover:-translate-y-0.5 hover:bg-slate-800 dark:bg-white dark:text-slate-950 dark:hover:bg-slate-200"
          >
            <FaPen />
            Modifier
          </button>
        </div>
      </div>
    </div>
  );
}